module.exports = __webpack_public_path__ + "img/cloud-hail-sun-2.9cd9736d.svg";